import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  CREATE_SERVICE,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_ERROR,
} from './../../../actionType'

function* createService({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: CREATE_SERVICE_SUCCESS, payload: response })
    } else {
      yield put({ type: CREATE_SERVICE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: CREATE_SERVICE_ERROR, payload: error })
  }
}

export function* watchCreateService() {
  yield takeEvery(CREATE_SERVICE, createService)
}

function* createServiceSaga() {
  yield all([fork(watchCreateService)])
}

export default createServiceSaga
